import React, { useContext } from 'react';

import { AppContext } from './App';

import { _Title as Title } from './components/Styled/Title';
import { _Container as Container } from './components/Styled/Container';
import ProgressiveImage from './components/ProgressiveImage/ProgressiveImage';

import FormContent from './FormContent';

import './App.css';
import { _PageWrapper as PageWrapper, _TwoColumnLayout as TwoColumnLayout } from './App.style';
import { MarkdownWrapper } from './components/Styled/FormDescription';

const FormWrapper = () => {
  const { urlParams, localization, formAttributes, previewMode } = useContext(AppContext);

  const { name, img, description } = formAttributes;

  const image = img?.data?.attributes;
  const imageSrc = image
    ? process.env.NODE_ENV === 'development'
      ? `http://localhost:1337${image.formats.small?.url || image.url}`
      : `${image.formats.medium?.url || image.url}`
    : '';
  const thumbnailSrc = image
    ? process.env.NODE_ENV === 'development'
      ? `http://localhost:1337${image.formats.thumbnail?.url || image.url}`
      : `${image.formats.thumbnail?.url || image.url}`
    : '';

  // Fallback width and height values
  const defaultWidth = 750;
  const defaultHeight = 750;

  return (
    <PageWrapper>
      {previewMode ? <pre>{localization.text.previewing}</pre> : ''}
      <Title>{name}</Title>
      <TwoColumnLayout>
        <Container width='50%' flexDirection='column' alignItems='center'>
          {image && (
            <ProgressiveImage
              placeholderSrc={thumbnailSrc}
              src={imageSrc}
              width={image.formats.medium?.width || defaultWidth}
              height={image.formats.medium?.height || defaultHeight}
              alt={image.alternativeText}
            />
          )}
          {description && <MarkdownWrapper>{description}</MarkdownWrapper>}
        </Container>

        <Container flexDirection='column'>
          <FormContent urlParams={urlParams} />
        </Container>
      </TwoColumnLayout>
    </PageWrapper>
  );
};

export default FormWrapper;
